/* eslint-disable react/no-children-prop */
import useExpandable from 'Hooks/useExpandable';
import React from 'react';
import { useIntl } from 'react-intl';
import ExpandableWrapper from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/ExpandableWrapper';
import AddTagButton from './components/AddTagButton';
import TagItems from './components/TagItems';
import {
  Wrapper
} from './styled';
import { selectAssetDetailId } from 'store/Contextualization/AssetDetail/selectors';
import { useSelector } from 'react-redux';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_TAGS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';

const ID = 'tags';

const Tags = ({ hostTags, entity, assetsGeneral }) => {
  const intl = useIntl();
  const hostId = useSelector(selectAssetDetailId);
  const isExpanded = useExpandable('general', ID, hostTags, hostId);
  const hasTagsFeature = useSelector((state) => selectAllowedByRole(state, FEATURE_TAGS, PERMISSION_TYPES.READ));

  if (!hasTagsFeature) return null;

  return (
    <ExpandableWrapper defaultValue={ isExpanded } id="tags" title={ intl.formatMessage({ id: 'manage.detail.tab.general.tags' }) } tab="general">
      <Wrapper>
        <TagItems hostTags={ hostTags } />
        <AddTagButton entity={ entity } assetsGeneral={ assetsGeneral } />
      </Wrapper>
    </ExpandableWrapper>
  );
};

export default Tags;
